import type { UsePersistedBlotterTable } from '@talos/kyoko';
import { useDateAndQuickTextFilter } from './useDateAndQuickTextFilter';

interface UseTransfersFilterParams {
  persistedBlotterTable: UsePersistedBlotterTable;
}

export function useTransfersFilter({ persistedBlotterTable }: UseTransfersFilterParams) {
  return useDateAndQuickTextFilter({ persistedBlotterTable });
}
